import React from "react";
import _ from "lodash";
import { Div, Row, Col, Text } from "atomize";
import CaseStudyCard from "../common/CaseStudyCard";
import BlogCard from "../common/BlogCard";
import StoryCard from "../common/StoryCard";
import CaseStudyCardMobile from "../casestudy/CaseStudyCardMobile";
import BlogCardMobile from "../blog/BlogCardMobile";
import StoryCardMobile from "../blog/StoryCardMobile";

const CardsListTwo = ({ category, data }) => {
  //   console.log(data, category);
  //   let cards = [];

  //   switch (category) {
  //     case "blogs":
  //       cards = blogs;
  //       break;
  //     case "case-studies":
  //       cards = caseStudies;
  //       break;
  //     default:
  //       // cards = cards;
  //       cards = generateMixedCards(caseStudies, blogs, 3);
  //   }

  function findCard(content, category) {
    // console.log(content.node.__typename);

    switch (category) {
      case "caseStudy":
        return <CaseStudyCard m={{ b: "30px" }} content={content} />;
        break;
      case "blog":
        return <BlogCard m={{ b: "30px" }} content={content} />;
        break;
      case "podcasts":
        return <StoryCard m={{ b: "30px" }} content={content} />;
        break;
    }
  }

  function findCardMobile(content, category) {
    switch (category) {
      case "caseStudy":
        return <CaseStudyCard m={{ b: "30px" }} content={content} />;
        break;
      case "blog":
        return <BlogCard m={{ b: "30px" }} content={content} />;
        break;
      case "podcasts":
        return <StoryCard m={{ b: "30px" }} content={content} />;
        break;
    }
  }

  return (
    <>
      <Row d={{ xs: "none", md: "flex" }} m={{ xs: "0 -8px", xl: "0 -15px" }}>
        {data.map((card, index) => (
          <Col
            size="4"
            p={{ xs: "0 8px", xl: "0 15px" }}
            key={`cards-list-${index}`}
          >
            {findCard(card, category)}
          </Col>
        ))}
      </Row>
      <Div d={{ md: "none" }}>
        {data.map((card, index) => {
          return findCardMobile(card, category);
        })}
      </Div>
    </>
  );
};

export default CardsListTwo;
